import { Http } from '@/utils';

/**
 * 首页服务类
 */
const Request = Http.getInstance();

 export class HomePageService {
     /**
      * 待上门工单量
      */
     public getVisitForm(type: string){
         return Request.get('/cssworkorderapi/woStatisticalForm/selectVisitSumForm',{type})
     }
     /**
      * 已回执工单量
      */
     public getReceiptForm(type: string) {
         return Request.get('/cssworkorderapi/woStatisticalForm/selectReceiptSumSumForm',{type})
     }
    /**
      * 超期遗留量
      */
     public getLeaveOver(type: string) {
        return Request.get('/cssworkorderapi/woStatisticalForm/selectLeaveOverSumSumForm',{type})
    }
    /**
      * 预约超期量
      */
     public getSubscribeOver(type: string) {
        return Request.get('/cssworkorderapi/woStatisticalForm/selectOverSubscribeSumSumForm',{type})
    }
    /**
      * 件到待上门量
      */
     public getDoor(type: string) {
        return Request.get('/cssworkorderapi/woStatisticalForm/selectForDoorSumSumForm',{type})
    }
    /**
      * 投诉量
      */
     public getComplain(type: string) {
        return Request.get('/cssworkorderapi/woStatisticalForm/selectComplaintSumSumForm',{type})
    }
    /**
      * 品类新增工单量概览
      */
     public getTypeAdd(type: string) {
        return Request.get('/cssworkorderapi/woStatisticalForm/selectTypeAddSumSumForm',{type})
    }
    /**
      * 渠道新增工单量概览
      */
     public getChannelAdd(type: string) {
        return Request.get('/cssworkorderapi/woStatisticalForm/selectChannelAddSumSumForm',{type})
    }

        /**
      * 12个月投诉量
      */
      public get12MonthComplain() {
          return Request.get('/cssworkorderapi/woStatisticalForm/findRecent12MonthComplainOrderNum')
      }
              /**
      * 12个回执工单
      */
      public get12MonthForm() {
          return Request.get('/cssworkorderapi/woStatisticalForm/findRecent12MonthHaveReceiptOrderNum')
      }




    /**
     * 获取公告数据
     */
    public getNotice(param : object) {
        return Request.get('/cssmobileplatformapi/mpnotices/querypagelist',param)
    }

    /**
     *
     * 获取公告详情
     */

    public getNoticeDetail(id : string) {
      return Request.get('/cssmobileplatformapi/mpnotices/'+ id)
    }

    /**
     * 获取OA代办列表
     */

    public getToList(param: object) {
      return Request.post('/csssparepartsapi/spOAReturn/getUserTaskPage',param)
    }
     /**
     * 获取已办
     */

      public getComplatedTask(param: object) {
        return Request.post('/csssparepartsapi/spOAReturn/getFinishTaskList',param)
      }
       /**
     * 获取已经发起
     */

    public getStarted(param: object) {
      return Request.post('/csssparepartsapi/spOAReturn/getMyRequestPage',param)
    }

    /**
     *  获取ssocode
     */
    public getSSOCode(token : string) {
      return Request.get('runtimeapi/jomoo/usercenter/getSwitchCode/' + token)
    }

    /**
     * 消息预警
     */

    public getMessage(param : object) {
      return Request.get('/runtimeapi/msgsends/fetchwebmsglist',param)
  }

  /**
   *
   * 服务商服务类投诉量
   */

   public ServiceProviderComplain(timeType: string) {
    return Request.get('/cssworkorderapi/woStatisticalForm4Network/findComplainOrderNum',{timeType})
  }
  /**
   *
   * 服务商已回执工单数量
   */
   public ServiceProviderReceipt(timeType: string) {
    return Request.get('/cssworkorderapi/woStatisticalForm4Network/findHaveReceiptWorkOrderNum',{timeType})
  }

  /**
   *  服务商超期遗留工单数量
   */
   public ServiceProviderOverdue(timeType: string) {
    return Request.get('/cssworkorderapi/woStatisticalForm4Network/findOverdueResidualOrderNum',{timeType})
  }

  /**
   * 服务商待上门工单数量
   */

   public ServiceProviderWaitDoor(timeType: string) {
    return Request.get('/cssworkorderapi/woStatisticalForm4Network/findWaitDoorOrderNum',{timeType})
  }

  /**
   * 服务商当日工程师领用数量
   */
   public ServiceProviderDayEngineerReceive() {
    return Request.get('/csssparepartsapi/spEngineerStock/getDayEngineerReceive')
  }

  /**
   *
   * 工单服务收益
   */
   public ServiceProviderOrderIncome() {
    return Request.get('/cssworkorderapi/woStatisticalForm/getOrderIncomeEveryServiceProvider')
  }

    /**
   *
   * 今日备件工单补库量
   */
     public ServiceProviderCountwonum() {
      return Request.get('/csssparepartsapi/sppurchases/countwonum')
    }

     /**
      *  获取ssocode
      */
     public getOASignUrl(url: string) {
         return Request.post('/csssparepartsapi/spOAReturn/getOASignUrl', {url: url})
     }
     /**
      *  获取新首页备件数据
      */
     public getSpHomePageAllData() {
         return Request.get('/csssparepartsapi/HomePage/getAll')
     }
     /**
      *  获取新首页数据
      */
     public getHomePageAllData() {
      //@ts-ignore
         let user = JSON.parse(localStorage.getItem("css_spare_parts_userInfo_"))
         console.log('user', user)
         //@ts-ignore
         let service_website = user.mdeptCode
         return Request.get(`/cssreportsapi/HomePage/getAll?service_website=${service_website}`)
     }






        /**
     * 日期格式化
     */
         public formatDate(params : any){
          let defalutParams = {
            date: new Date(),
            formatStr: 'yyyy-MM-dd HH:mm:ss'
          }
          params = { ...defalutParams, ...params };
          let date = params.date;
          let formatStr = params.formatStr;
          // 传入日期字符串 - 转成时间戳 - 转成标准时间
          let timeStamp = new Date(date).getTime();
          date = new Date(timeStamp);
          formatStr = formatStr.replace(new RegExp('yyyy'), `${date.getFullYear()}`);
          const month = date.getMonth() + 1;
          formatStr = formatStr.replace(new RegExp('MM'), `${month > 9 ? month : '0' + month}`);
          const day = date.getDate();
          formatStr = formatStr.replace(new RegExp('dd'), `${day > 9 ? day : '0' + day}`);
          const hour = date.getHours();
          formatStr = formatStr.replace(new RegExp('HH'), `${hour > 9 ? hour : '0' + hour}`);
          const min = date.getMinutes();
          formatStr = formatStr.replace(new RegExp('mm'), `${min > 9 ? min : '0' + min}`);
          const sec = date.getSeconds();
          formatStr = formatStr.replace(new RegExp('ss'), `${sec > 9 ? sec : '0' + sec}`);
          return formatStr;
        }
 }

 export default new HomePageService